// Claude 15 Oct 2026 (Michael): Upcart was removed from the Shopify App Store, so the theme's own cart drawer is dressed the same way:
// "Your Bag", gift strip (boxers 149 instead of 199 - Shopify automatic discount), free-shipping line, clean item rows,
// "The Perfect Extras" swipe row (boxers + spray first, then Shopify's matching products) and a round CHECKOUT button with the total.
(function () {
    // after "add to cart" open this cart (the theme setting was "message" because Upcart used to open its own cart)
    try { var tv = window.themeVariables && window.themeVariables.settings; if (tv && tv.cartType === 'message') tv.cartType = 'drawer'; } catch (e) {}
    // Michael: The Perfect Extras = only the boxers, the spray and Colorful Standard tees (in this order)
    var FIXED = ['mr-something-brief-boxers-3-color-pack', 'something-sexy-mevasem', 'something-sexy-diffuser',
        'colorfoul-standard-oversized-organic-t-shirt-deep-black', 'colorfoul-standard-oversized-organic-t-shirt-ivory-white',
        'colorfoul-standard-oversized-organic-t-shirt-dusty-olive', 'colorfoul-standard-classic-organic-tee-optical-white'];
    var BOXER = /boxers/i, FREE_FROM = 250;
    var products = {}, recs = {}, cart = null, cartAt = 0, loading = {};

    function money(cents) { return (Math.round(cents) / 100).toLocaleString('en-US', { maximumFractionDigits: 2 }) + ' ₪'; }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function img(src, w) { if (!src) return ''; src = src.indexOf('//') === 0 ? 'https:' + src : src; return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w; }
    function strip(title, vendor) {
        var t = (title || '').trim();
        if (vendor && t.toLowerCase().indexOf(vendor.toLowerCase()) === 0) t = t.slice(vendor.length).replace(/^[\s\-|]+/, '');
        return t;
    }
    function splitColour(t) { var m = t.match(/^(.+?)\s+in\s+(.+)$/); return m ? { name: m[1], colour: m[2] } : { name: t, colour: '' }; }
    function getJSON(url) { return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }

    function loadCart(force) {
        if (!force && cart && Date.now() - cartAt < 1500) return Promise.resolve(cart);
        if (loading.cart) return loading.cart;
        loading.cart = getJSON('/cart.js').then(function (c) { cart = c; cartAt = Date.now(); loading.cart = null; return c; }, function (e) { loading.cart = null; throw e; });
        return loading.cart;
    }
    function loadProduct(h) {
        if (products[h] !== undefined) return Promise.resolve(products[h]);
        return getJSON('/products/' + h + '.js').then(function (p) { products[h] = p; return p; }, function () { products[h] = null; return null; });
    }
    function loadRecs(pid) {
        if (recs[pid]) return Promise.resolve(recs[pid]);
        return getJSON('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related').then(function (r) {
            recs[pid] = r.products || []; (recs[pid]).forEach(function (p) { products[p.handle] = p; }); return recs[pid];
        }, function () { recs[pid] = []; return []; });
    }

    function drawer() { return document.getElementById('mini-cart'); }

    // ---------- header / strip / shipping / items / footer ----------
    function paintStatic(root, c) {
        var hasBoxer = c.items.some(function (i) { return BOXER.test(i.handle || i.url || ''); });
        // header: Your Bag ( 1 ITEM )
        var title = root.querySelector('.drawer__title');
        if (title) {
            var label = '( ' + c.item_count + (c.item_count === 1 ? ' ITEM' : ' ITEMS') + ' )';
            var want = '<span class="mrs-bag">Your Bag</span><span class="mrs-bag__count">' + label + '</span>';
            if (title.getAttribute('data-mrs') !== label) { title.innerHTML = want; title.setAttribute('data-mrs', label); }
        }
        if (!c.item_count) return;
        var content = root.querySelector('.drawer__content');
        if (!content) return;
        // gift strip (only while no boxer pack is in the bag)
        var strip = content.querySelector('.mrs-gift');
        if (!hasBoxer && !strip) {
            strip = document.createElement('div'); strip.className = 'mrs-gift'; strip.setAttribute('dir', 'rtl');
            strip.innerHTML = 'הטבה אישית להזמנה שלך: 🎁 מארז בוקסרים ב־149₪ במקום 199₪';
            content.insertBefore(strip, content.firstChild);
        } else if (hasBoxer && strip) strip.remove();
        // free shipping line
        var bar = content.querySelector('.shipping-bar__text');
        if (bar) {
            var total = c.items.reduce(function (s, i) { return s + (i.requires_shipping ? i.final_line_price : 0); }, 0);
            var left = FREE_FROM * 100 - total;
            var txt = left <= 0 ? 'FREE SHIPPING UNLOCKED!' : money(left).toUpperCase() + ' AWAY FROM FREE SHIPPING';
            if (bar.textContent !== txt) bar.textContent = txt;
        }
        // item rows
        var rows = root.querySelectorAll('#mini-cart-form line-item');
        rows.forEach(function (row, idx) {
            var li = c.items[idx]; if (!li) return;
            var key = li.key + ':' + li.quantity;
            if (row.getAttribute('data-mrs') === key) return;
            row.setAttribute('data-mrs', key);
            var t = row.querySelector('.product-item-meta__title');
            var sc = splitColour(strip_(li));
            if (t) t.textContent = sc.name;
            var props = row.querySelector('.product-item-meta__property-list');
            var meta = row.querySelector('.product-item-meta');
            var box = row.querySelector('.mrs-li-props');
            if (!box && meta) { box = document.createElement('div'); box.className = 'mrs-li-props'; (t && t.nextSibling) ? meta.insertBefore(box, t.nextSibling) : meta.appendChild(box); }
            var size = (li.variant_title && li.variant_title !== 'Default Title') ? li.variant_title : '';
            if (box) box.innerHTML = (sc.colour ? '<span>Colour: ' + esc(sc.colour) + '</span>' : '') + (size ? '<span class="mrs-li-size">Size: ' + esc(size) + '</span>' : '');
            if (props) props.style.display = 'none';
            // price under colour / size (crossed-out price next to it when discounted)
            var wrap = row.querySelector('.line-item__content-wrapper');
            var p = row.querySelector('.mrs-li-price');
            if (!p && (box || wrap)) { p = document.createElement('div'); p.className = 'mrs-li-price'; if (box) box.parentNode.insertBefore(p, box.nextSibling); else wrap.appendChild(p); }
            if (p) p.innerHTML = (li.original_line_price > li.final_line_price ? '<s>' + money(li.original_line_price) + '</s>' : '') + '<b>' + money(li.final_line_price) + '</b>';
            row.querySelectorAll('.line-item__discount-badge').forEach(function (b) { if (/\(-\D*0(?:[.,]00)?\D*\)\s*$/.test(b.textContent.trim())) b.classList.add('mrs-zero'); });
            // the photo is shown bigger now - load a sharper copy (theme asks for an 80px one)
            var im = row.querySelector('.line-item__image'); if (im && im.getAttribute('sizes') !== '160px') im.setAttribute('sizes', '160px');
            var rm = row.querySelector('.line-item__remove-button');
            if (rm && rm.textContent.trim() !== 'Remove') rm.textContent = 'Remove';
        });
        // footer: Subtotal row + CHECKOUT ...... total
        var foot = root.querySelector('.mini-cart__drawer-footer');
        if (foot) {
            var sub = foot.querySelector('.mrs-sub');
            if (!sub) { sub = document.createElement('div'); sub.className = 'mrs-sub'; var btn0 = foot.querySelector('.checkout-button'); foot.insertBefore(sub, btn0 || null); }
            var subHtml = '<span>Subtotal</span><span>' + money(c.total_price) + '</span>';
            if (sub.innerHTML !== subHtml) sub.innerHTML = subHtml;
            var btn = foot.querySelector('.checkout-button');
            if (btn && btn.getAttribute('data-mrs') !== String(c.total_price)) {
                btn.innerHTML = '<span>CHECKOUT</span><span>' + money(c.total_price) + '</span>';
                btn.setAttribute('data-mrs', String(c.total_price));
            }
        }
    }
    function strip_(li) { return strip(li.product_title, li.vendor); }

    // ---------- The Perfect Extras ----------
    function card(p, offer) {
        var v = p.variants.filter(function (x) { return x.available; });
        if (!v.length) return '';
        var vendor = p.vendor || '', name = strip(p.title, vendor);
        var isBoxer = BOXER.test(p.handle);
        var price = v[0].price, cmp = v[0].compare_at_price;
        var showOffer = isBoxer && offer;
        var priceHtml = showOffer ? '<s>' + money(price) + '</s><b>' + money(price - 5000) + '</b>'
            : (cmp && cmp > price ? '<s>' + money(cmp) + '</s><b>' + money(price) + '</b>' : '<b>' + money(price) + '</b>');
        var single = p.variants.length === 1 && /default/i.test(p.variants[0].title);
        var sel = single ? '<input type="hidden" name="id" value="' + v[0].id + '">'
            : '<select name="id" aria-label="מידה">' + v.map(function (x) { return '<option value="' + x.id + '">' + esc(x.title) + '</option>'; }).join('') + '</select>';
        var label = showOffer ? 'הוסיפו ב־149₪' : 'הוסיפו לסל';
        var im = p.featured_image || (p.images && p.images[0]) || '';
        return '<div class="mrs-x__card">' +
            '<a class="mrs-x__img" href="/products/' + p.handle + '"><img src="' + esc(img(im, 400)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
            '<p class="mrs-x__brand">' + esc(vendor) + '</p>' +
            '<a class="mrs-x__name" href="/products/' + p.handle + '">' + esc(name) + '</a>' +
            '<p class="mrs-x__price">' + priceHtml + '</p>' +
            '<form class="mrs-x__form' + (single ? ' is-single' : '') + '">' + sel + '<button type="submit">' + label + '</button></form>' +
            '</div>';
    }
    function paintExtras(root, c) {
        var content = root.querySelector('.drawer__content');
        if (!content || !c.item_count) return;
        var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = 1; });
        var hasBoxer = c.items.some(function (i) { return BOXER.test(i.handle || ''); });
        var hasOther = c.items.some(function (i) { return !BOXER.test(i.handle || ''); });
        Promise.all(FIXED.map(loadProduct)).then(function (res) {
            var list = [], seen = {};
            res.forEach(function (p) {
                if (!p || seen[p.id] || inCart[p.id] || !p.available) return;
                if (hasBoxer && BOXER.test(p.handle)) return;
                seen[p.id] = 1; list.push(p);
            });
            list = list.slice(0, 8);
            var html = list.map(function (p) { return card(p, hasOther && !hasBoxer); }).join('');
            var box = content.querySelector('.mrs-x');
            if (!html) { if (box) box.remove(); return; }
            var sig = c.token + ':' + c.item_count + ':' + list.map(function (p) { return p.id; }).join(',');
            if (box && box.getAttribute('data-mrs') === sig) return;
            if (!box) { box = document.createElement('div'); box.className = 'mrs-x'; content.appendChild(box); }
            box.setAttribute('data-mrs', sig);
            box.innerHTML = '<p class="mrs-x__h">The Perfect Extras</p><div class="mrs-x__row">' + html + '</div>';
        });
    }

    // add from the extras row
    document.addEventListener('submit', function (e) {
        var f = e.target.closest && e.target.closest('.mrs-x__form');
        if (!f) return;
        e.preventDefault();
        var btn = f.querySelector('button'); if (btn.disabled) return;
        btn.disabled = true; btn.setAttribute('data-label', btn.textContent); btn.textContent = '...';
        fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(f.querySelector('[name="id"]').value), quantity: 1 }] }) })
            .then(function (r) { return r.json(); })
            .then(function () { return loadCart(true); })
            .then(function (c) {
                document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
            })
            .catch(function () { btn.disabled = false; btn.textContent = btn.getAttribute('data-label'); });
    }, true);

    // ---------- run after every redraw of the drawer ----------
    var timer = null, watched = null, mo = new MutationObserver(queue);
    function queue() { if (timer) return; timer = setTimeout(run, 40); }
    function run() {
        timer = null;
        var root = drawer(); if (!root) return;
        mo.disconnect();
        var go = function (c) { try { paintStatic(root, c); paintExtras(root, c); } catch (e) { if (window.console) console.warn('mrs-cart', e); } observe(); };
        loadCart(false).then(go, observe);
    }
    function observe() { var root = drawer(); if (root) mo.observe(root, { childList: true, subtree: true }); }
    document.documentElement.addEventListener('cart:refresh', function () { cartAt = 0; });
    document.documentElement.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart && e.detail.cart.items) { cart = e.detail.cart; cartAt = Date.now(); } });
    function start() { run(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
// Claude 15 Oct 2026 (Michael): take down the expired Flashy "End of year 20% OFF" popup (code ended 31.12.25).
// Only that popup is removed - any other Flashy popup still shows.
(function () {
    var OLD = /End of year|20%\s*OFF/i;
    function sweep(root) {
        var list = (root.querySelectorAll ? root.querySelectorAll('.fls-popup-overlay') : []);
        for (var i = 0; i < list.length; i++) {
            var o = list[i];
            if (OLD.test(o.textContent || '') || OLD.test(o.innerHTML || '')) {
                o.remove();
                document.documentElement.style.removeProperty('overflow'); document.body.style.removeProperty('overflow');
            }
        }
    }
    // Oct 2026: Flashy now draws the popup as <flashy-popup> with everything (text included) in one image inside a shadow root
    var IMG = /uvyJ72ag/;
    function sweepNew() {
        var list = document.querySelectorAll('flashy-popup');
        for (var i = 0; i < list.length; i++) {
            var sr = list[i].shadowRoot, h = sr ? sr.innerHTML : '';
            if (IMG.test(h) || OLD.test(h) || (sr && OLD.test(sr.textContent || ''))) {
                list[i].remove();
                document.documentElement.style.removeProperty('overflow'); document.body.style.removeProperty('overflow');
            }
        }
    }
    // 16 Oct: lighter - page changes are batched to one check per frame, and everything stops after 3 minutes
    var raf = 0;
    var mo = new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sweep(document); sweepNew(); }); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    sweep(document); sweepNew();
    // the shadow content is filled in after the element appears, so re-check only while a Flashy popup is on the page
    var n = 0, iv = setInterval(function () { if (document.querySelector('flashy-popup')) sweepNew(); if (++n > 180) { clearInterval(iv); mo.disconnect(); } }, 1000);
})();

// Claude 16 Oct 2026 (Michael): hide the cart count dot on the header bag when the bag is empty.
(function () {
    function sync() { var c = document.querySelectorAll('.header cart-count'); for (var i = 0; i < c.length; i++) c[i].classList.toggle('mrs-zero', (c[i].textContent || '').trim() === '0'); }
    function start() { sync(); var c = document.querySelectorAll('.header cart-count'); for (var i = 0; i < c.length; i++) new MutationObserver(sync).observe(c[i], { childList: true, characterData: true, subtree: true }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
// Claude 16 Oct 2026 (Michael): boxer offer on every product page, right above ADD TO CART.
// Tick it, pick colour + size, and the pack goes into the bag together with the item at 149 (automatic discount "הטבה אישית: בוקסרים ב־149 ₪").
// Not shown on the boxer pages themselves or on gift cards.
(function () {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var here = decodeURIComponent(m[1]);
    if (/boxer|gift-?card|giftcard/i.test(here)) return;
    var PACKS = [
        { handle: 'mr-something-brief-boxers-3-color-pack', name: 'שחור, לבן ואפור' }
    ];
    var data = {}, pick = 0, size = null, box = null, busy = false;
    function el(t, c, h) { var e = document.createElement(t); if (c) e.className = c; if (h != null) e.innerHTML = h; return e; }
    function img(u) { if (!u) return ''; if (u.indexOf('//') === 0) u = 'https:' + u; return u.split('?')[0] + '?width=180'; }
    function load() {
        return Promise.all(PACKS.map(function (p) {
            return fetch('/products/' + p.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { data[p.handle] = j; }).catch(function () {});
        }));
    }
    function cur() { return data[PACKS[pick].handle]; }
    function render() {
        var p = cur(); if (!p || !box) return;
        box.querySelector('.mrs-bx__img').src = img(p.featured_image);
        var row = box.querySelector('.mrs-bx__sizes'); row.innerHTML = '';
        p.variants.forEach(function (v) {
            var b = el('button', 'mrs-bx__size', v.title); b.type = 'button';
            if (!v.available) { b.disabled = true; if (size === v.title) size = null; }
            b.setAttribute('aria-pressed', size === v.title ? 'true' : 'false');
            b.addEventListener('click', function () { size = v.title; box.classList.remove('mrs-bx--need'); setOn(true); render(); });
            row.appendChild(b);
        });
    }
    function setOn(on) { box.classList.toggle('is-on', on); box.querySelector('.mrs-bx__tick').setAttribute('aria-checked', on ? 'true' : 'false'); if (!on) box.classList.remove('mrs-bx--need'); }
    function build() {
        box = el('div', 'mrs-bx');
        box.innerHTML =
            '<div class="mrs-bx__top">' +
              '<span class="mrs-bx__tick" role="checkbox" aria-checked="false" tabindex="0"></span>' +
              '<div class="mrs-bx__txt"><p class="mrs-bx__h">הוסיפו מארז בוקסרים Mr.Something</p>' +
              '<p class="mrs-bx__p"><b>149₪</b> במקום <s>199₪</s></p><p class="mrs-bx__sub">שלישיית בוקסרים: שחור, לבן ואפור</p></div>' +
              '<span class="mrs-bx__ph"><img class="mrs-bx__img" alt="Mr.Something boxers" width="64" height="64"></span>' +
            '</div>' +
            '<div class="mrs-bx__opts">' +
              '<div class="mrs-bx__row"><span class="mrs-bx__lbl">מידה</span><div class="mrs-bx__sizes"></div></div>' +
              '<p class="mrs-bx__need">בחרו מידה לבוקסרים</p>' +
            '</div>';
        var top = box.querySelector('.mrs-bx__top');
        top.addEventListener('click', function () { setOn(!box.classList.contains('is-on')); });
        box.querySelector('.mrs-bx__tick').addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); setOn(!box.classList.contains('is-on')); } });
        render();
        return box;
    }
    function anchor() {
        var btn = document.getElementById('AddToCart'); if (!btn) return;
        var bb = btn.closest('.product-form__buy-buttons'); if (!bb || bb.closest('quick-buy-drawer, quick-buy-popover, .product-sticky-form')) return;
        if (!box) build();
        if (bb.previousElementSibling !== box) bb.parentNode.insertBefore(box, bb);
    }
    // add the pack first, then let the theme add the item and open the bag with both inside
    document.addEventListener('submit', function (e) {
        var f = e.target, btn = document.getElementById('AddToCart');
        if (!box || !btn || btn.form !== f || f.__mrsBx || !box.classList.contains('is-on')) return;
        var p = cur(), v = null;
        if (p) for (var i = 0; i < p.variants.length; i++) if (p.variants[i].title === size && p.variants[i].available) v = p.variants[i];
        e.preventDefault(); e.stopImmediatePropagation();
        if (!v) { box.classList.add('mrs-bx--need'); box.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
        if (busy) return; busy = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
            .catch(function () {})
            .then(function () {
                busy = false; setOn(false);
                f.__mrsBx = true;
                if (f.requestSubmit) f.requestSubmit(btn); else btn.click();
                setTimeout(function () { f.__mrsBx = false; }, 0);
            });
    }, true);
    function start() {
        load().then(function () {
            if (!PACKS.some(function (p) { return data[p.handle] && data[p.handle].available; })) return;
            for (var i = 0; i < PACKS.length; i++) if (data[PACKS[i].handle] && data[PACKS[i].handle].available) { pick = i; break; }
            anchor();
            var n = 0, iv = setInterval(function () { anchor(); if (++n > 40) clearInterval(iv); }, 500);
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

// Claude 16 Oct 2026 (Michael): "Seen in the lookbook" line on product pages of pieces that appear in the Something Else lookbook.
(function () {
    var LB = ["belier-gaston-relaxed-fit-trouser-light-beige", "belier-monaco-chino-trouser-stone", "briglia-1949-bg61-sabbia", "briglia-1949-imperia-military-pants", "briglia-1949-imperia-ocean-blue-pants", "briglia-1949-portofinod-gesso", "cleens-ace-woven-phantom-sneakers", "colorfoul-standard-merino-quarter-zip-navy-blue", "colorfoul-standard-organic-flannel-shirt-deep-black", "colorfoul-standard-organic-flannel-shirt-dusty-olive", "colorfoul-standard-organic-quarter-zip-faded-grey", "drykorn-anton-brown-fitted-t-shirt", "drykorn-anton-navy-fitted-t-shirt", "drykorn-anton-white-fitted-t-shirt-1", "drykorn-baunt-brown-regular-fit-shirt", "drykorn-brairan-black-knitted-polo-shirt", "drykorn-chasy-black-regular-fit-trousers", "drykorn-daneel-classic-slim-fit-long-sleeve-shirt-1", "drykorn-kailep-black-half-zip-sweatshirt", "drykorn-leek-black-wide-trousers", "drykorn-tamian-1506-relaxed-knit-polo-shirt", "drykorn-triton-navy-polo-shirt", "enterprise-japan-jupiter-rocket-sneakers-in-grey-military-leather-and-suede", "garden-of-god-earth-hairy-suede-taupe", "golden-goose-ballstar-2-suede-upper-and-spur-leather-star-and-heel", "golden-goose-purestar-leather-sneakers-in-white-with-a-star-shiny-leather-heel", "golden-goose-stardan-suede-toe-nylon-tongue-suede-upper-leather-star-and-heel", "golden-goose-super-star-leather-upper-star-and-heel", "golden-goose-super-star-vintage-leather-upper-leather-star-and-heel-rubber-toe"];
    var ST = ["diet-starts-monday-atelier-jacket-vintage-black", "diet-starts-monday-bolt-panel-long-sleeve-red-purple", "diet-starts-monday-collegiate-overlap-hoodie-tan-purple", "diet-starts-monday-crinkled-flannel-navy-tan", "diet-starts-monday-double-layer-trouble-tee-antique-white-red", "diet-starts-monday-double-layer-trouble-tee-vintage-black-white", "diet-starts-monday-dsm-double-layer-hoodie-heather-grey-vintage-black", "diet-starts-monday-hollywood-waffle-polo-green", "diet-starts-monday-hopkins-pant-washed-navy", "diet-starts-monday-hopkins-work-jacket-washed-navy", "diet-starts-monday-option-atelier-jacket-lavender", "diet-starts-monday-repair-cargo-pants-vintage-black", "diet-starts-monday-repair-cargo-pants-washed-olive", "diet-starts-monday-repair-sweatpants-vintage-black", "diet-starts-monday-thunder-long-sleeve-red", "diet-starts-monday-work-pants-lavender", "diet-starts-monday-work-pants-vintage-black", "duke-dexter-dr1-world-championship-vintage-black-jacket", "duke-dexter-dr4-cream-racing-polo", "duke-dexter-dr4-washed-black-track-long-sleeve-top", "enterprise-japan-egg-rocket-sneakers-in-menta-sky-bianco-suede-and-nubuck", "enterprise-japan-egg-rocket-sneakers-in-orchidea-lilla-bianco-suede-and-nubuck", "enterprise-japan-egg-rocket-sneakers-in-salmone-ruggine-bianco-suede-and-nubuck", "haikure-achilles-cut-hammer-black-trousers", "haikure-achilles-pollock-white-jeans", "haikure-achilles-velvet-pier-jeans", "haikure-tokyo-slim-ziggy-blue-trousers", "maison-mihara-yasuhiro-a16fw705-white", "maison-mihara-yasuhiro-a16fw726-white", "mki-denim-classic-bleach-wash-jean", "reternity-le-promeneur-cow-leather-sneakers-1", "reternity-le-promeneur-washed-cream-sneakers", "reternity-le-promeneur-white-sneakers-1"];
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return;
    var h = decodeURIComponent(m[1]), url = LB.indexOf(h) > -1 ? '/pages/lookbook-something-else' : (ST.indexOf(h) > -1 ? '/pages/lookbook-street' : null);
    if (!url) return;
    function add() {
        if (document.querySelector('.mrs-seen')) return true;
        var head = document.querySelector('.mrs-lux-head') && getComputedStyle(document.querySelector('.mrs-lux-head')).display !== 'none' ? document.querySelector('.mrs-lux-head') : document.querySelector('.product-meta');
        if (!head) return false;
        var a = document.createElement('a'); a.className = 'mrs-seen'; a.href = url;
        a.innerHTML = '<span>Seen in the lookbook</span><i>→</i>';
        head.appendChild(a); return true;
    }
    var n = 0, iv = setInterval(function () { if (add() || ++n > 20) clearInterval(iv); }, 300);
})();
